import React, { useState, useEffect } from "react";
import { useNavigate, useParams,useLocation } from "react-router-dom";
import axiosInstance from "../../../../axiosInstance";
import { API_URL } from "../../../../config";

function EmpPostAJobPage() {
    const location = useLocation();
    const navigate = useNavigate();
    const subscription = location.state?.subscription;

    const [formData, setFormData] = useState({
        title: "",
        price: "",
        time: "",
        type: "",
        status: "",
        description: "",
    });

    useEffect(() => {
        if (subscription) {
            setFormData({
                title: subscription.title || "",
                price: subscription.price || "",
                time: subscription.time || "",
                type: subscription.type || "",
                status: subscription.status || "",
                description: subscription.description || "",
            });
        }
    }, [subscription]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axiosInstance.put(`${API_URL}/admin/edit_Subscription/${subscription.id}`, formData);
            if (response.data.status === 200) {
                alert("Subscription updated successfully!");
                navigate("/employer/subscription"); // redirect back to subscription page
            } else {
                alert("Failed to update subscription.");
            }
        } catch (error) {
            console.error("Error updating subscription", error);
            alert("Something went wrong!");
        }
    };

    return (
        <>
            <div className="wt-admin-right-page-header clearfix">
                <h2>Subscription Edit</h2>
                <div className="breadcrumbs"><a href="#">Home</a><a href="#">Dasboard</a><span>Subscription Edit Form</span></div>
            </div>

            {/*Basic Information*/}
            <div className="panel panel-default">
                <div className="panel-heading wt-panel-heading p-a20">
                    <h4 className="panel-tittle m-a0"><i className="fa fa-suitcase" />Subscription Edit</h4>
                </div>
                <div className="panel-body wt-panel-body p-a20 m-b30 ">
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            {/*Job title*/}
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Package Name</label>
                                    <div className="ls-inputicon-box">
                                        <input
                                            className="form-control"
                                            name="title"
                                            type="text"
                                            placeholder="Package Name"
                                            value={formData.title}
                                            onChange={handleChange}
                                        />
                                        <i className="fs-input-icon fa fa-address-card" />
                                    </div>
                                </div>
                            </div>
                            {/*Job Category - This is a placeholder and needs to be dynamic based on your actual categories*/}
                            {/* <div className="col-xl-4 col-lg-6 col-md-12"> */}
                            {/* <div className="form-group city-outer-bx has-feedback"> */}
                            {/* <label>Job Category</label> */}
                            {/* <div className="ls-inputicon-box"> */}
                            {/* <select
                                            className="wt-select-box selectpicker"
                                            data-live-search="true"
                                            title=""
                                            id="j-category"
                                            data-bv-field="size"
                                            name="category" // You might need a category field in your formData
                                            value={formData.category || ''} // Adjust if your API has a category field
                                            onChange={handleChange}
                                        > */}
                            {/* <option disabled value="">Select Category</option>
                                            <option>Accounting and Finance</option>
                                            <option>Clerical &amp; Data Entry</option> */}
                            {/* Add other categories dynamically from your backend if needed */}
                            {/* </select> */}
                            {/* <i className="fs-input-icon fa fa-border-all" /> */}
                            {/* </div> */}
                            {/* </div> */}
                            {/* </div> */}
                            {/*Job Type*/}
                            {/* <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Job Type</label>
                                    <div className="ls-inputicon-box">
                                        <select
                                            className="wt-select-box selectpicker"
                                            data-live-search="true"
                                            title=""
                                            id="s-category"
                                            data-bv-field="size"
                                            name="type"
                                            value={formData.type}
                                            onChange={handleChange}
                                        >
                                            <option className="bs-title-option" value="">Select Category</option>
                                            <option value="Full Time">Full Time</option>
                                            <option value="Freelance">Freelance</option>
                                            <option value="Part Time">Part Time</option>
                                            <option value="Internship">Internship</option>
                                            <option value="Temporary">Temporary</option>
                                        </select>
                                        <i className="fs-input-icon fa fa-file-alt" />
                                    </div>
                                </div>
                            </div> */}
                            {/*Offered Salary - Using text input for simplicity, adjust as needed*/}
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Price</label>
                                    <div className="ls-inputicon-box">
                                        <input
                                            className="form-control"
                                            name="price"
                                            type="text"
                                            placeholder="Plan Price"
                                            value={formData.price}
                                            onChange={handleChange}
                                        />
                                        <i className="fs-input-icon fa fa-dollar-sign" />
                                    </div>
                                </div>
                            </div>
                            {/*Time*/}
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Time</label>
                                    <div className="ls-inputicon-box">
                                        <input
                                            className="form-control"
                                            name="time"
                                            type="text"
                                            placeholder="Time (e.g., Monthly, Hourly)"
                                            value={formData.time}
                                            onChange={handleChange}
                                        />
                                        <i className="fs-input-icon fa fa-clock" />
                                    </div>
                                </div>
                            </div>
                            {/*Status*/}
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Status</label>
                                    <div className="ls-inputicon-box">
                                        <select
                                            className="wt-select-box selectpicker"
                                            data-live-search="true"
                                            title=""
                                            id="status"
                                            data-bv-field="size"
                                            name="status"
                                            value={formData.status}
                                            onChange={handleChange}
                                        >
                                            <option className="bs-title-option" value="">Select Status</option>
                                            <option value="active">Active</option>
                                            <option value="inactive">Inactive</option>
                                        </select>
                                        <i className="fs-input-icon fa fa-info-circle" />
                                    </div>
                                </div>
                            </div>
                            {/* The rest of your form fields - these are not directly tied to the API payload you mentioned */}
                            {/* You can either remove them or connect them to the formData state if needed for other purposes */}
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Type</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control" name="experience" type="text" placeholder="E.g. Minimum 3 years" value={formData.type}/>
                                        <i className="fs-input-icon fa fa-user-edit" />
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Qualification</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control" name="qualification" type="text" placeholder="Qualification Title" />
                                        <i className="fs-input-icon fa fa-user-graduate" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Gender</label>
                                    <div className="ls-inputicon-box">
                                        <select className="wt-select-box selectpicker" data-live-search="true" title="" id="gender" data-bv-field="size">
                                            <option className="bs-title-option" value>Gender</option>
                                            <option>Male</option>
                                            <option>Female</option>
                                            <option>Other</option>
                                        </select>
                                        <i className="fs-input-icon fa fa-venus-mars" />
                                    </div>
                                </div>
                            </div> */}
                            {/* <div className="col-xl-4 col-lg-6 col-md-12"> */}
                            {/* <div className="form-group"> */}
                            {/* <label>Country</label> */}
                            {/* <div className="ls-inputicon-box"> */}
                            {/* <select className="wt-select-box selectpicker" data-live-search="true" title="" id="country" data-bv-field="size"> */}
                            {/* <option className="bs-title-option" value>Country</option>
                                            <option>Afghanistan</option>
                                            <option>Albania</option> */}
                            {/* ... more countries ... */}
                            {/* </select> */}
                            {/* <i className="fs-input-icon fa fa-globe-americas" /> */}
                            {/* </div> */}
                            {/* </div> */}
                            {/* </div> */}
                            {/* <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>City</label>
                                    <div className="ls-inputicon-box">
                                        <select className="wt-select-box selectpicker" data-live-search="true" title="" id="city" data-bv-field="size">
                                            <option className="bs-title-option" value>City</option>
                                            <option>Sydney</option>
                                            <option>Melbourne</option>
                                            ... more cities ...
                                        </select>
                                        <i className="fs-input-icon fa fa-map-marker-alt" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Location</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control" name="location" type="text" placeholder="Type Address" />
                                        <i className="fs-input-icon fa fa-map-marker-alt" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Latitude</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control" name="latitude" type="text" placeholder="Latitude" />
                                        <i className="fs-input-icon fa fa-map-pin" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Longitude</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control" name="longitude" type="text" placeholder="Longitude" />
                                        <i className="fs-input-icon fa fa-map-pin" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Email Address</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control" name="email" type="email" placeholder="Devid@example.com" />
                                        <i className="fs-input-icon fas fa-at" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Website</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control" name="website" type="text" placeholder="https://..." />
                                        <i className="fs-input-icon fa fa-globe-americas" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Est. Since</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control" name="established_since" type="text" placeholder="Since..." />
                                        <i className="fs-input-icon fa fa-clock" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-12 col-lg-6 col-md-12">
                                <div className="form-group">
                                    <label>Complete Address</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control" name="address" type="text" placeholder="1363-1385 Sunset Blvd Los Angeles, CA 90026, USA" />
                                        <i className="fs-input-icon fa fa-home" />
                                    </div>
                                </div>
                            </div> */}
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Description</label>
                                    <textarea
                                        className="form-control"
                                        rows={3}
                                        placeholder="Greetings! We are Galaxy Software Development Company. We hope you enjoy our services and quality."
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                    />
                                </div>
                            </div>
                            {/* <div className="col-md-6">
                                <div className="form-group">
                                    <label>Start Date</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control datepicker" data-provide="datepicker" name="start_date" type="text" placeholder="mm/dd/yyyy" />
                                        <i className="fs-input-icon far fa-calendar" />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>End Date</label>
                                    <div className="ls-inputicon-box">
                                        <input className="form-control datepicker" data-provide="datepicker" name="end_date" type="text" placeholder="mm/dd/yyyy" />
                                        <i className="fs-input-icon far fa-calendar" />
                                    </div>
                                </div>
                            </div> */}
                            <div className="col-lg-12 col-md-12">
                                <div className="text-left">
                                    <button type="submit" className="site-button m-r5">Update Subscription</button>
                                    {/* The "Save Draft" button doesn't interact with the API based on your provided information */}
                                    {/* <button type="button" className="site-button outline-primary">Save Draft</button> */}
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default EmpPostAJobPage;














// import React, { useState, useEffect } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import axiosInstance from "../../../../axiosInstance";
// import { API_URL } from "../../../../config";

// function EmpPostAJobPage() {
//     const { id } = useParams();
//     const navigate = useNavigate();
//     const [formData, setFormData] = useState({
//         title: '',
//         description: '',
//         price: '',
//         time: '',
//         status: '',
//         type: ''
//     });

//     useEffect(() => {
//         const fetchSubscriptionDetails = async () => {
//             try {
//                 const response = await axiosInstance.get(`${API_URL}/admin/candidate-list/${id}`); // Assuming an endpoint to fetch single subscription details
//                 setFormData(response.data); // Adjust based on your API response structure
//             } catch (error) {
//                 console.error("Error fetching subscription details", error);
//                 alert("Error fetching subscription details.");
//             }
//         };

//         if (id) {
//             fetchSubscriptionDetails();
//         }
//     }, [id]);

//     const handleChange = (e) => {
//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
//         const payload = {
//             title: formData.title,
//             description: formData.description,
//             price: formData.price,
//             time: formData.time,
//             status: formData.status,
//             type: formData.type,
//         };
//         try {
//             await axiosInstance.put(`${API_URL}/edit_Subscription/${id}`, payload);
//             alert("Subscription updated successfully!");
//             navigate('/admin/subscription-list'); // Redirect to the subscription list page after successful update
//         } catch (error) {
//             console.error("Update error", error);
//             alert("Error updating subscription.");
//         }
//     };

//     return (
//         <>
//             <div className="wt-admin-right-page-header clearfix">
//                 <h2>Subscription Edit</h2>
//                 <div className="breadcrumbs"><a href="#">Home</a><a href="#">Dasboard</a><span>Subscription Edit Form</span></div>
//             </div>

//             {/*Basic Information*/}
//             <div className="panel panel-default">
//                 <div className="panel-heading wt-panel-heading p-a20">
//                     <h4 className="panel-tittle m-a0"><i className="fa fa-suitcase" />Subscription Edit</h4>
//                 </div>
//                 <div className="panel-body wt-panel-body p-a20 m-b30 ">
//                     <form onSubmit={handleSubmit}>
//                         <div className="row">
//                             {/*Job title*/}
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Job Title</label>
//                                     <div className="ls-inputicon-box">
//                                         <input
//                                             className="form-control"
//                                             name="title"
//                                             type="text"
//                                             placeholder="Job Title"
//                                             value={formData.title}
//                                             onChange={handleChange}
//                                         />
//                                         <i className="fs-input-icon fa fa-address-card" />
//                                     </div>
//                                 </div>
//                             </div>
//                             {/*Job Category - This is a placeholder and needs to be dynamic based on your actual categories*/}
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group city-outer-bx has-feedback">
//                                     <label>Job Category</label>
//                                     <div className="ls-inputicon-box">
//                                         <select
//                                             className="wt-select-box selectpicker"
//                                             data-live-search="true"
//                                             title=""
//                                             id="j-category"
//                                             data-bv-field="size"
//                                             name="category" // You might need a category field in your formData
//                                             value={formData.category || ''} // Adjust if your API has a category field
//                                             onChange={handleChange}
//                                         >
//                                             <option disabled value="">Select Category</option>
//                                             <option>Accounting and Finance</option>
//                                             <option>Clerical &amp; Data Entry</option>
//                                             {/* Add other categories dynamically from your backend if needed */}
//                                         </select>
//                                         <i className="fs-input-icon fa fa-border-all" />
//                                     </div>
//                                 </div>
//                             </div>
//                             {/*Job Type*/}
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Job Type</label>
//                                     <div className="ls-inputicon-box">
//                                         <select
//                                             className="wt-select-box selectpicker"
//                                             data-live-search="true"
//                                             title=""
//                                             id="s-category"
//                                             data-bv-field="size"
//                                             name="type"
//                                             value={formData.type}
//                                             onChange={handleChange}
//                                         >
//                                             <option className="bs-title-option" value="">Select Category</option>
//                                             <option value="Full Time">Full Time</option>
//                                             <option value="Freelance">Freelance</option>
//                                             <option value="Part Time">Part Time</option>
//                                             <option value="Internship">Internship</option>
//                                             <option value="Temporary">Temporary</option>
//                                         </select>
//                                         <i className="fs-input-icon fa fa-file-alt" />
//                                     </div>
//                                 </div>
//                             </div>
//                             {/*Offered Salary - Using text input for simplicity, adjust as needed*/}
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Offered Salary</label>
//                                     <div className="ls-inputicon-box">
//                                         <input
//                                             className="form-control"
//                                             name="price"
//                                             type="text"
//                                             placeholder="Offered Salary"
//                                             value={formData.price}
//                                             onChange={handleChange}
//                                         />
//                                         <i className="fs-input-icon fa fa-dollar-sign" />
//                                     </div>
//                                 </div>
//                             </div>
//                             {/*Time*/}
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Time</label>
//                                     <div className="ls-inputicon-box">
//                                         <input
//                                             className="form-control"
//                                             name="time"
//                                             type="text"
//                                             placeholder="Time (e.g., Monthly, Hourly)"
//                                             value={formData.time}
//                                             onChange={handleChange}
//                                         />
//                                         <i className="fs-input-icon fa fa-clock" />
//                                     </div>
//                                 </div>
//                             </div>
//                             {/*Status*/}
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Status</label>
//                                     <div className="ls-inputicon-box">
//                                         <select
//                                             className="wt-select-box selectpicker"
//                                             data-live-search="true"
//                                             title=""
//                                             id="status"
//                                             data-bv-field="size"
//                                             name="status"
//                                             value={formData.status}
//                                             onChange={handleChange}
//                                         >
//                                             <option className="bs-title-option" value="">Select Status</option>
//                                             <option value="active">Active</option>
//                                             <option value="inactive">Inactive</option>
//                                             <option value="pending">Pending</option>
//                                             <option value="closed">Closed</option>
//                                         </select>
//                                         <i className="fs-input-icon fa fa-info-circle" />
//                                     </div>
//                                 </div>
//                             </div>

//                             {/* The rest of your form fields - these are not directly tied to the API payload you mentioned */}
//                             {/* You can either remove them or connect them to the formData state if needed for other purposes */}
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Experience</label>
//                                     <div className="ls-inputicon-box">
//                                         <input className="form-control" name="experience" type="text" placeholder="E.g. Minimum 3 years" />
//                                         <i className="fs-input-icon fa fa-user-edit" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Qualification</label>
//                                     <div className="ls-inputicon-box">
//                                         <input className="form-control" name="qualification" type="text" placeholder="Qualification Title" />
//                                         <i className="fs-input-icon fa fa-user-graduate" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Gender</label>
//                                     <div className="ls-inputicon-box">
//                                         <select className="wt-select-box selectpicker" data-live-search="true" title="" id="gender" data-bv-field="size">
//                                             <option className="bs-title-option" value>Gender</option>
//                                             <option>Male</option>
//                                             <option>Female</option>
//                                             <option>Other</option>
//                                         </select>
//                                         <i className="fs-input-icon fa fa-venus-mars" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Country</label>
//                                     <div className="ls-inputicon-box">
//                                         <select className="wt-select-box selectpicker" data-live-search="true" title="" id="country" data-bv-field="size">
//                                             <option className="bs-title-option" value>Country</option>
//                                             <option>Afghanistan</option>
//                                             <option>Albania</option>
//                                             {/* ... more countries ... */}
//                                         </select>
//                                         <i className="fs-input-icon fa fa-globe-americas" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>City</label>
//                                     <div className="ls-inputicon-box">
//                                         <select className="wt-select-box selectpicker" data-live-search="true" title="" id="city" data-bv-field="size">
//                                             <option className="bs-title-option" value>City</option>
//                                             <option>Sydney</option>
//                                             <option>Melbourne</option>
//                                             {/* ... more cities ... */}
//                                         </select>
//                                         <i className="fs-input-icon fa fa-map-marker-alt" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Location</label>
//                                     <div className="ls-inputicon-box">
//                                         <input className="form-control" name="location" type="text" placeholder="Type Address" />
//                                         <i className="fs-input-icon fa fa-map-marker-alt" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Latitude</label>
//                                     <div className="ls-inputicon-box">
//                                         <input className="form-control" name="latitude" type="text" placeholder="Latitude" />
//                                         <i className="fs-input-icon fa fa-map-pin" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Longitude</label>
//                                     <div className="ls-inputicon-box">
//                                         <input className="form-control" name="longitude" type="text" placeholder="Longitude" />
//                                         <i className="fs-input-icon fa fa-map-pin" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Email Address</label>
//                                     <div className="ls-inputicon-box">
//                                         <input className="form-control" name="email" type="email" placeholder="Devid@example.com" />
//                                         <i className="fs-input-icon fas fa-at" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Website</label>
//                                     <div className="ls-inputicon-box">
//                                         <input className="form-control" name="website" type="text" placeholder="https://..." />
//                                         <i className="fs-input-icon fa fa-globe-americas" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-4 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Est. Since</label>
//                                     <div className="ls-inputicon-box">
//                                         <input className="form-control" name="established_since" type="text" placeholder="Since..." />
//                                         <i className="fs-input-icon fa fa-clock" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-xl-12 col-lg-6 col-md-12">
//                                 <div className="form-group">
//                                     <label>Complete Address</label>
//                                     <div className="ls-inputicon-box">
//                                         <input className="form-control" name="address" type="text" placeholder="1363-1385 Sunset Blvd Los Angeles, CA 90026, USA" />
//                                         <i className="fs-input-icon fa fa-home" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-md-12">
//                                 <div className="form-group">
//                                     <label>Description</label>
//                                     <textarea
//                                         className="form-control"
//                                         rows={3}
//                                         placeholder="Greetings! We are Galaxy Software Development Company. We hope you enjoy our services and quality."
//                                         name="description"
//                                         value={formData.description}
//                                         onChange={handleChange}
//                                     />
//                                 </div>
//                             </div>
//                             <div className="col-md-6">
//                                 <div className="form-group">
//                                     <label>Start Date</label>
//                                     <div className="ls-inputicon-box">
//                                         <input className="form-control datepicker" data-provide="datepicker" name="start_date" type="text" placeholder="mm/dd/yyyy" />
//                                         <i className="fs-input-icon far fa-calendar" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-md-6">
//                                 <div className="form-group">
//                                     <label>End Date</label>
//                                     <div className="ls-inputicon-box">
//                                         <input className="form-control datepicker" data-provide="datepicker" name="end_date" type="text" placeholder="mm/dd/yyyy" />
//                                         <i className="fs-input-icon far fa-calendar" />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-lg-12 col-md-12">
//                                 <div className="text-left">
//                                     <button type="submit" className="site-button m-r5">Update Subscription</button>
//                                     {/* The "Save Draft" button doesn't interact with the API based on your provided information */}
//                                     <button type="button" className="site-button outline-primary">Save Draft</button>
//                                 </div>
//                             </div>
//                         </div>
//                     </form>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default EmpPostAJobPage;